import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { IconButton, Typography } from '@mui/material'
import { GridFooter, GridFooterContainer, GridPaginationModel } from '@mui/x-data-grid'

interface props {
  pagination: GridPaginationModel
  setPagination: (pagination: GridPaginationModel) => void
  disabledPreview: boolean
  disabledNext: boolean
}

const Footer = ({ pagination, setPagination, disabledPreview, disabledNext }: props) => {
  return (
    <GridFooterContainer>
      <GridFooter sx={{ '& .MuiTablePagination-actions, & .MuiTablePagination-displayedRows': { display: 'none' } }} />
      <div style={{ display: 'flex' }}>
        <IconButton
          onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })}
          disabled={disabledPreview}
          sx={{
            border: 1,
            borderColor: disabledPreview ? 'action.disabledBackground' : 'divider',
            width: '2rem',
            height: '2rem',
            mr: '10px',
          }}
        >
          <KeyboardArrowLeftIcon />
        </IconButton>
        <Typography
          sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: `20px`,
            width: '2rem',
            height: '2rem',
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            flexWrap: 'wrap',
            mr: '10px',
          }}
        >
          {pagination.page + 1}
        </Typography>
        <IconButton
          onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })}
          disabled={disabledNext}
          sx={{
            border: 1,
            borderColor: disabledNext ? 'action.disabledBackground' : 'divider',
            width: '2rem',
            height: '2rem',
            mr: '10px',
          }}
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </div>
    </GridFooterContainer>
  )
}

export default Footer
